import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";
import { enUS } from "date-fns/locale";
import { CalendarToolbar } from "./CalendarToolbar";
import { CalendarEvent } from "./CalendarEvent";
import { WeekHeader } from "./WeekHeader";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { AVATAR_COLORS } from "../../utils/commonUtils";
import { MoreEventsPopup } from "./MoreEventsPopup";
import { useState } from "react";

const locales = {
    "en-US": enUS,
};

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
});

const formats = {
    monthHeaderFormat: "MMM",
    timeGutterFormat: "hh:mm a",
};

const getColorIndexFromLetter = (str) => {
    if (!str) return 0;
    const firstLetter = str.charAt(0).toUpperCase();
    const letterIndex = firstLetter.charCodeAt(0) - 65;
    return letterIndex % AVATAR_COLORS.length;
};

const getColorByEventType = (title) => {
    const lowerTitle = title.toLowerCase();
    if (lowerTitle.includes('thematic')) return 'thematic';
    if (lowerTitle.includes('ci')) return 'ci';
    if (lowerTitle.includes('initiation')) return 'initiation';
    if (lowerTitle.includes('cis')) return 'cis';
    if (lowerTitle.includes('scorecard')) return 'scorecard';
    if (lowerTitle.includes('qi')) return 'qi';
    if (lowerTitle.includes('sector-update')) return 'sector-update';
    if (lowerTitle.includes('planned')) return 'planned';
    return null;
};

const eventStyleGetter = (event) => {
    const specificColor = getColorByEventType(event.engagementGroup || event.publicationGroup||  event.title);
    if (specificColor) {
        return {
            className: specificColor
        };
    }

    const colorIndex = getColorIndexFromLetter(event.engagementGroup || event.publicationGroup|| event.title);
    if (!event.colorIndex) {
        event.colorIndex = colorIndex;
    }
    return {
        className: `event-color-${event.colorIndex || colorIndex}`
    };
};


export function CustomCalendar({
    events,
    onSelectEvent,
    onNavigate,
    view,
    onView,
}) {
    const [moreEventsPopup, setMoreEventsPopup] = useState({
        show: false,
        events: [],
        position: { x: 0, y: 0 },
        date: null
    });

    const modifiedEvents = events?.map((event) => ({
        ...event,
        view,
    }));

    const handleShowMore = (events, date, slotInfo) => {
        if (slotInfo?.action === 'click' || slotInfo?.action === 'doubleClick') {
            slotInfo.preventDefault();
        }

        const mouseEvent = window.event || {};

        setMoreEventsPopup({
            show: true,
            events,
            date,
            position: {
                x: mouseEvent.clientX || window.innerWidth / 2,
                y: mouseEvent.clientY || window.innerHeight / 2
            }
        });
    };

    return (
        <div className={`${view === 'day' || view === 'week' ? 'h-auto' : 'h-[800px]'}`}>
            <Calendar
                localizer={localizer}
                events={modifiedEvents}
                startAccessor="start"
                endAccessor="end"
                onSelectEvent={onSelectEvent}
                onNavigate={onNavigate}
                view={view}
                onView={onView}
                formats={formats}
                components={{
                    toolbar: CalendarToolbar,
                    event: CalendarEvent,
                    week: {
                        header: WeekHeader,
                    },
                }}
                className="custom-calendar"
                step={60}
                timeslots={1}
                eventPropGetter={eventStyleGetter}
                onShowMore={handleShowMore}
                doShowMoreDrillDown={false}
            />

            {moreEventsPopup.show && (
                <MoreEventsPopup
                    events={moreEventsPopup.events}
                    date={moreEventsPopup.date}
                    position={moreEventsPopup.position}
                    onClose={() => setMoreEventsPopup({ show: false, events: [], position: { x: 0, y: 0 }, date: null })}
                />
            )}
        </div>
    );
}
